import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ArrowRight } from 'lucide-react';
import { motion } from 'framer-motion';

interface HeadlineProps {
  title: string;
  size?: number;
  viewAllLink?: string;
  animate?: boolean;
}

export function Headline({ title, size = 2, viewAllLink = null, animate = true }: HeadlineProps) {
  const { t } = useTranslation();
  
  const HeadingComponent = animate ? motion.h2 : 'h2';
  const LinkComponent = animate ? motion.div : 'div';
  
  return (
    <div className="flex justify-between items-center mb-8">
      <HeadingComponent
        initial={animate ? { opacity: 0, x: -20 } : undefined}
        whileInView={animate ? { opacity: 1, x: 0 } : undefined}
        transition={{ duration: 0.5 }}
        className={`font-tilt-warp text-${size}xl text-light`}
      >
        {title}
      </HeadingComponent>
      {viewAllLink && (
        <LinkComponent
          initial={animate ? { opacity: 0, x: 20 } : undefined}
          whileInView={animate ? { opacity: 1, x: 0 } : undefined}
          transition={{ duration: 0.5 }}
        >
          <Link aria-label={t('common.viewAll')} to={`/${viewAllLink}`} className="text-primary hover:text-light flex items-center group">
            <span className="hidden md:block">{t('common.viewAll')}</span>
            <ArrowRight className="ml-1 w-7 md:w-4 h-7 md:h-4 transform transition-transform group-hover:translate-x-1" />
          </Link>
        </LinkComponent>
      )}
    </div>
  );
}